import type { ReactNode } from 'react'
import { cn } from '@/utils/cn'

type Props = {
  children: ReactNode
  className?: string
}

export function PageShell({ children, className }: Props) {
  return (
    <div
      className={cn(
        'dashboard-page dashboard-canvas -mx-4 min-h-full px-4 pb-6 sm:-mx-6 sm:px-6 sm:pb-8',
        className,
      )}
    >
      <div className="dashboard-stack">{children}</div>
    </div>
  )
}
